import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

import { readCiType, readCiTypeImageBlobUrl, readCiTypes } from "../services/ciTypesApi";

export function useCiTypeQuery(publicId, isOpen) {
  const { t } = useTranslation();

  return useQuery({
    queryKey: ["citypes", publicId],
    queryFn: () => readCiType(publicId),
    enabled: isOpen && !!publicId,
    gcTime: 0,
    onError: (error) => {
      toast.error(error.message || t("item.messages.fetchError"));
    },
  });
}

export function useCiTypeImageBlobUrlQuery(publicId, enabled) {
  return useQuery({
    queryKey: ["ciTypeIcon", publicId],
    queryFn: () => readCiTypeImageBlobUrl(publicId),
    enabled: enabled && !!publicId,
    gcTime: 0,
  });
}

export function useCiTypesQuery() {
  return useQuery({
    queryKey: ["citypes"],
    queryFn: () => readCiTypes(),
  });
}
